import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http';
import { BrowserDynamicTestingModule } from '@angular/platform-browser-dynamic/testing';
import {
  aquisition,
  DeleteTagsParam,
  Hold,
  HoldList,
  memberData,
  memberDataEdit,
  ResponseBlock,
  ResponseHoldList,
  ResponseHolds,
  ResponseLostItemHistory,
  ResponseMissing,
  responseReviewList,
  ResponseSuggestList,
  responseTagsCloudBookList,
  reviewDataAdd,
  SuggestFriendModel,
  SuggestFriendParam,
  TagCloudDataAdd,
  TagCloudNameList,
  UserPassword,
} from '../models/walai';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NDDBasketData, NDDBasketlistResponse } from '../models/modelNDD';
import { NDDRequestData } from '../models/ReqDetail';
import { ApiConfig, ConfigService } from './config.service';
import { login } from '../member/login/login.component';



@Injectable({
  providedIn: 'root',
})
export class MemberService {
  // private baseUrl = '';
  private _apiconfig: ApiConfig;
  private apiUrl = '';
  private token = '';
  private apiSSOAuth = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    this._apiconfig = this.configService.apiConfig;
    this.apiUrl = this._apiconfig.url;
    this.token = this._apiconfig.token;
    this.apiSSOAuth = this.configService.apiSSOAuth;
    //this.header.append('authorization','');
    //this.header.append('Content-Type', 'application/json');
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //authorization: ''
    }),
  };

  private handleError(err: HttpErrorResponse): Observable<never> {
    return throwError(() => err);
  }

  //log in เข้าสู่ระบบ
  userLogin(val: login, dbWalai: boolean) {
    let apiUrl = '';
    if (dbWalai) {
      apiUrl = `${this.apiUrl}/api/opacLoginWalaiDB`;
    } else {
      apiUrl = `${this.apiUrl}/api/opacLogin`;
    }

    console.log('val', val);
console.log('apiUrl', apiUrl);


    return this.http.post<any>(apiUrl, val, this.httpOptions);
  }

  //log in เข้าสู่ระบบของ UBU
  // userUBULogin(val: any) {
  //   this.baseUrl = `${environment.apiUBULogin}`;  //apiSSOAuth
  //   return this.http.post<any>(this.baseUrl, val, this.httpOptions);
  // }

  public userUBULogin(val: login): Observable<any> {
    const user = {
      "username": this.base64Encode(val.username),
      "password": this.base64Encode(val.password)
    }
    
    return this.http
      .post<any>(this.apiSSOAuth, user, { observe: 'response' })
      .pipe(catchError(this.handleError));
  }

  //แก้ไขข้อมูล
  userEdit(val: memberDataEdit) {
    return this.http.put<any>(
      `${this.apiUrl}/api/opacMemberUpdateData`,
      val,
      this.httpOptions
    );
  }

  // public UploadProfilePicture(file: FormData, id: string): Observable<any> {
  //   const headers = {
  //     headers: new HttpHeaders().set('accept', 'application/json'),
  //   };
  //   return this.http.post<any>(
  //     `${this.apiUrl}/api/UploadProfilePicture/${id}`,
  //     file,
  //     headers
  //   );
  // }

  public UploadProfilePicture(file: FormData, id: string): Observable<any> {
    return this.http
      .post<any>(`${this.apiUrl}/api/UploadProfilePicture/${id}`, file, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  //แสดงประวัติการยืม
  opacMemberHistory(id) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/opacMemberHistory/${id}`,
      this.httpOptions
    );
  }

  //MemberData
  getMemberData(id) {
    return this.http.get<memberData[]>(
      `${this.apiUrl}/api/MemberData/${id}`,
      this.httpOptions
    );
  }

  //แสดงรายการยืม
  opacMemberBorrow(id) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/opacMemberBorrow/${id}`,
      this.httpOptions
    );
  }

  //แสดงการใช้งานเงินมัดจำ
  opacMemberGetBalance(id) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/GetBalance/${id}`,
      this.httpOptions
    );
  }

  //แสดงการใช้งานเงินมัดจำ
  opacMemberGetNotice(id) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/GetNotice/${id}`,
      this.httpOptions
    );
  }

  //แสดงรายการจอง
  opacMemberGetItemHold(id) {
    return this.http.get<ResponseHolds>(
      `${this.apiUrl}/api/GetItemHold/${id}`,
      this.httpOptions
    );
  }

  //แสดงรายการ ฺBlock
  GetBlockNotice(id) {
    return this.http.get<ResponseBlock>(
      `${this.apiUrl}/api/GetBlockNotice/${id}`,
      this.httpOptions
    );
  }

  //แสดงรายการ ฺ Missing
  GetLostItem(id) {
    return this.http.get<ResponseMissing>(
      `${this.apiUrl}/api/GetLostItem/${id}`,
      this.httpOptions
    );
  }

  //แสดงรายการ ฺ Lost Item History
  GetLostItemHistory(id) {
    return this.http.get<ResponseLostItemHistory>(
      `${this.apiUrl}/api/GetLostItemHistory/${id}`,
      this.httpOptions
    );
  }

  //แสดงรายการค่าปรับ
  opacMemberGetRfine(id) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/opacMemberRFine/${id}`,
      this.httpOptions
    );
  }

  //แสดงรายการ Collection
  opacMemberGetCollection(id, bibid) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/opacMemberCollection/${id}/${bibid}`,
      this.httpOptions
    );
  }

  opacMemberCollectionAdd(val: any) {
    return this.http.put<any>(
      `${this.apiUrl}/api/opacMemberCollectionAdd`,
      val,
      this.httpOptions
    );
  }

  opacMemberCollectionEdit(val: any) {
    return this.http.put<any>(
      `${this.apiUrl}/api/opacMemberCollectionEdit`,
      val,
      this.httpOptions
    );
  }

  opacMemberCollectionDelete(mlid) {
    return this.http.delete<any>(
      `${this.apiUrl}/api/opacMemberCollectionDelete/${mlid}`,
      this.httpOptions
    );
  }

  opacMemberCollectionAddBib(val: any) {
    return this.http.put<any>(
      `${this.apiUrl}/api/opacMemberCollectionAddBib`,
      val,
      this.httpOptions
    );
  }

  opacMemberCollectionDeleteBib(mlid, bibid) {
    return this.http.delete<any>(
      `${this.apiUrl}/api/opacMemberCollectionDeleteBib/${mlid}/${bibid}`,
      this.httpOptions
    );
  }

  opacMemberCollectionDeleteBibByMBID(MBID) {
    return this.http.delete<any>(
      `${this.apiUrl}/api/opacMemberCollectionDeleteBibBymbid/${MBID}`,
      this.httpOptions
    );
  }

  opacMemberGetCollectionDetail(mlid) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/opacMemberCollectionDetail/${mlid}`,
      this.httpOptions
    );
  }

  //จองทรัพยากร
  userHoldItem(id, barcode) {
    //ไว้ส่งค่า
    // let body = new URLSearchParams();
    // body.set('barcode', barcode);
    const payload = new HttpParams().set('barcode', barcode);

    //Api จากพี่รัตรรับค่าเป็น x-www-form-urlencoded
    return this.http.post<any>(`${this.apiUrl}/api/HoldItem/${id}`, payload, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  userCancelHoldItem(id, holdid: string) {
    return this.http.delete<any>(
      `${this.apiUrl}/api/opacMemberDeleteHold/${id}/${holdid}`,
      this.httpOptions
    );
  }

  userCancelHoldItemList(id, Holds: HoldList[]) {
    return this.http.post<ResponseHoldList[]>(
      `${this.apiUrl}/api/opacMemberDeleteHoldList/${id}`,
      Holds,
      this.httpOptions
    );
  }

  //Renew หนังสือ
  userRenew(id, barcode) {
    //ไว้ส่งค่า
    const payload = new HttpParams().set('barcode', barcode);
    //Api(By P'Ratt) รับค่าเป็น x-www-form-urlencoded
    return this.http.post<any>(`${this.apiUrl}/api/RenewItem/${id}`, payload, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  //Renew หนังสือแบบเป็น List
  userRenewList(id, BarcodeList: HoldList[]) {
    return this.http.post<ResponseHoldList[]>(
      `${this.apiUrl}/api/RenewItemList/${id}`,
      BarcodeList,
      this.httpOptions
    );
  }

  //แนะนำ หนังสือ
  acqSuggestionAdd(id, acq: aquisition) {
    //ไว้ส่งค่า
    // let body = new URLSearchParams();
    // body.set('barcode', barcode);
    const payload = new HttpParams()
      .set('title', acq.title)
      .set('author', acq.author)
      .set('amount', acq.amount)
      .set('isn', acq.isn)
      .set('prices', acq.prices)
      .set('reason', acq.reason);

    //Api จากพี่รัตรรับค่าเป็น x-www-form-urlencoded
    return this.http.post<any>(
      `${this.apiUrl}/api/AcqSuggestion/${id}`,
      payload,
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      }
    );
  }

  //แสดงรายการแนะนำหนังสือ
  opacMemberSuggestList(id) {
    return this.http.get<ResponseSuggestList>(
      `${this.apiUrl}/api/AcqSuggestion/${id}`,
      this.httpOptions
    );
  }

  public reviewDelete(id: string): Observable<any> {
    return this.http.delete<any[]>(
      `${this.apiUrl}/api/deleteReview/${id}`,
      this.httpOptions
    );
  }

  addMemberReview(val: reviewDataAdd): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/api/bookAddReview`,
      val,
      this.httpOptions
    );
  }

  updateMemberReview(val: reviewDataAdd): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/api/bookUpdateReview`,
      val,
      this.httpOptions
    );
  }

  //get Reviews count
  opacMemberGetReviewsCount(id) {
    return this.http.get<number>(
      `${this.apiUrl}/api/reviewCount/${id}`,
      this.httpOptions
    );
  }

  opacMemberReviewList(id, currentPage, perPage) {
    return this.http.get<responseReviewList>(
      `${this.apiUrl}/api/reviewListMember/${id}/${currentPage}/${perPage}`,
      this.httpOptions
    );
  }

  /**status user สำหรับ Request Delivery */
  getBlockNotice(id) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/GetBlockNotice/${id}`,
      this.httpOptions
    );
  }

  public NDDAddBasket(userid: string, NDDBasketData: any): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/api/NDDAddBasket/${userid}`, NDDBasketData, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  //NDDBasketlist
  NDDBasketlist(id) {
    return this.http.get<NDDBasketlistResponse>(
      `${this.apiUrl}/api/NDDBasketlist/${id}`,
      this.httpOptions
    );
  }

  public NDDRemovefromBasket(
    userid: string,
    ddinbasketid: string
  ): Observable<any> {
    return this.http
      .put<any>(
        `${this.apiUrl}/api/NDDRemovefromBasket/${userid}/${ddinbasketid}`,
        {
          observe: 'response',
        }
      )
      .pipe(catchError(this.handleError));
  }

  getNDDMemberEmail(id) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/NDDMemberEmail/${id}`,
      this.httpOptions
    );
  }

  public getNDDMemberAddress(id): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/api/NDDMemberAddress/${id}`, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  public UpdateNDDMemberAddress(id, formAddress: any): Observable<any> {
    const payload = new HttpParams()
      .set('ADDRESS', formAddress.ADDRESS)
      .set('PROVINCEID', formAddress.PROVINCEID)
      .set('DISTRICTID', formAddress.DISTRICTID)
      .set('POSTCODE', formAddress.POSTCODE)
      .set('TEL', formAddress.TEL)
      .set('EMAIL', formAddress.EMAIL);

    return this.http.post<any>(
      `${this.apiUrl}/api/NDDMemberAddress/${id}`,
      payload,
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      }
    );

    // const payload = new HttpParams()
    // .set('ADDRESS', formAddress.ADDRESS)
    // .set('PROVINCEID', formAddress.PROVINCEID)
    // .set('DISTRICTID', formAddress.DISTRICTID)
    // .set('POSTCODE', formAddress.POSTCODE)
    // .set('TEL', formAddress.TEL)
    // .set('EMAIL', formAddress.EMAIL);

    // return this.http.post<any>(`${this.apiUrl}/api/NDDMemberAddress/${id}`, payload ,
    //   {
    //      headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
    //   })
    //   .pipe(catchError(this.handleError));
  }

  getNDDProvince() {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/NDDProvince`,
      this.httpOptions
    );
  }

  getNDDDistrictbyProvince(id) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/NDDDistrictbyProvince?provinceid=${id}`,
      this.httpOptions
    );
  }

  getNDDPostcode(id) {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/NDDPostcode?districtid=${id}`,
      this.httpOptions
    );
  }

  getNDDPointShow(id) {
    return this.http.get<any>(
      `${this.apiUrl}/api/NDDPointShow/${id}`,
      this.httpOptions
    );
  }

  getNDDUserPrivilege(id) {
    return this.http.get<any>(
      `${this.apiUrl}/api/NDDUserPrivilege/${id}`,
      this.httpOptions
    );
  }

  NDDPointTimeShow(locationid, pointid) {
    return this.http.get<any>(
      `${this.apiUrl}/api/NDDPointTimeShow/${locationid}/${pointid}`,
      this.httpOptions
    );
  }

  public NDDTypeOpen(loationid): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/api/NDDTypeOpen/${loationid}`, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  public NDDEditBasket(
    userid,
    ddinbasketid,
    nddBasketData: NDDBasketData
  ): Observable<any> {
    return this.http
      .put<any>(
        `${this.apiUrl}/api/NDDEditBasket/${userid}/${ddinbasketid}`,
        nddBasketData,
        { observe: 'response' }
      )
      .pipe(catchError(this.handleError));
  }

  public NDDShippingCost(): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/api/NDDShippingCost`, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  public NDDAddRequest(
    userid,
    ddinbasketid,
    NddRequestData: NDDRequestData
  ): Observable<any> {
    return this.http
      .post<any>(
        `${this.apiUrl}/api/NDDAddRequest/${userid}/${ddinbasketid}`,
        NddRequestData,
        { observe: 'response' }
      )
      .pipe(catchError(this.handleError));
  }

  NDDAgreement(id) {
    return this.http.get<any>(
      `${this.apiUrl}/api/NDDAgreement/${id}`,
      this.httpOptions
    );
  }

  getLoginType() {
    return this.http.get<string>(
      `${this.apiUrl}/api/loginType`,
      this.httpOptions
    );
  }

  // public updatePassword(userid,password: UserPassword): Observable<any> {
  //   return this.http.put<any>( `${this.apiUrl}/api/UserPassword/${userid}`,
  //   password,
  //     { observe: 'response' }).pipe(catchError(this.handleError));
  // }

  public updatePassword(userid, password: UserPassword): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/api/UserPassword/${userid}`, password, {
        observe: 'response',
      })
      .pipe(map((response) => response));
  }

  updatePassword1(userid, password: UserPassword) {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${this.apiUrl}/api/UserPassword/${userid}`, password, {
          observe: 'response',
        })
        .subscribe(
          (response) => {
            if (response.status == 200) {
              resolve(200);
            } else {
              resolve('');
            }
          },
          (err) => {
            const error = err.error?.Message;
            //     const error = err.error?.error_description || err.error?.Message || err.statusText;
            return resolve(error);
          }
        );
    });
  }

  // updatePassword1(userid,password: UserPassword):  Observable<any> {
  //   return this.http.put<any>( `${this.apiUrl}/api/UserPassword/${userid}`,
  //   password, {
  //     headers: this.header,
  //   });
  // }

  addMemberTagCloud(val: TagCloudDataAdd): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/api/AddTags`,
      val,
      this.httpOptions
    );
  }

  //get Tag
  opacMemberGetUserTag(id) {
    return this.http.get<TagCloudNameList[]>(
      `${this.apiUrl}/api/GetUserTag/${id}`,
      this.httpOptions
    );
  }

  opacMemberGetUserTagDetail(id, tagWord) {
    return this.http.get<responseTagsCloudBookList>(
      `${this.apiUrl}/api/GetUserTagDetail/${id}/${tagWord}/1/1000`,
      this.httpOptions
    );
  }

  opacMemberDeleteTag(val: DeleteTagsParam) {
    return this.http.post<any>(
      `${this.apiUrl}/api/DeleteTag`,
      val,
      this.httpOptions
    );
  }

  opacMemberSuggestFriend(val: SuggestFriendParam) {
    return this.http.post<any>(
      `${this.apiUrl}/api/opacMemberSuggestFriend`,
      val,
      this.httpOptions
    );
  }

  OpacMemberGetSuggestFriendList(id) {
    return this.http.get<SuggestFriendModel[]>(
      `${this.apiUrl}/api/GetSuggestFriendList/${id}`,
      this.httpOptions
    );
  }

  public DeleteSuggestFriend(SFID: string): Observable<any> {
    return this.http.delete<any[]>(
      `${this.apiUrl}/api/DeleteSuggestFriend?SFID=${SFID}`,
      this.httpOptions
    );
  }

  //SelfCheck
  public getSelfCheckFlag(): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/api/useselfcheck`, { observe: 'response' })
      .pipe(catchError(this.handleError));
  }

  public updateSelfCheckPin(userId: string, userPin: number): Observable<any> {
    const _userPin = new URLSearchParams();
    _userPin.append('pin', userPin.toString());
    return this.http
      .put<any>(`${this.apiUrl}/api/selfcheckpin/${userId}`, _userPin, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  private base64Encode(str: string): string {
    const utf8Bytes = new TextEncoder().encode(str);
    const binary = Array.from(utf8Bytes)
      .map(b => String.fromCharCode(b))
      .join('');
    return btoa(binary);
  }
}
